import { Observable } from 'rxjs';
import { NotificationEvent } from '../interfaces';

export abstract class NotificationEngineService {
  public abstract get notificationChannelConnectionStateChanged(): Observable<boolean>;

  public abstract get notificationChannelCleared(): Observable<void>;

  public abstract get notificationChannelInitialMessagesLoaded(): Observable<NotificationEvent[]>;

  public abstract get notificationMessageAdded(): Observable<NotificationEvent>;

  public abstract get notificationMessageRemoved(): Observable<string>;

  public abstract removeNotification(messageId: string): void;
}
